
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { VatsApi, Vat, GraphsApi, EventTypesApi } from '../../api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4plugins_timeline from '@amcharts/amcharts4/plugins/timeline';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import * as am4plugins_overlapBuster from '@amcharts/amcharts4/plugins/overlapBuster';
import { BIconHourglass } from 'bootstrap-vue';
import { EventType, filterEntityEventTypes } from '@/models/event-subscription';
import { animateExpand, animateExpand2 } from '@/common/ChartUtil';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: { BIconHourglass },
})
export default class ChartAdmin extends Vue {
	@Prop()
	public vatId!: number;

	@Prop()
	public vatEmptyDistance!: number;

	@Prop()
	public vatSizeString!: string | number;

	@Prop()
	public vatOffset!: number;

	@Prop()
	public formula!: string;

	@Prop()
	public height!: number;

	@Prop()
	public complianceMethod!: string;

	public lineChart: am4charts.XYChart;
	public indicator;
	public indicatorInterval;
	public specialEventTypes = [];

	public dateForm = {
		start: moment()
			.subtract(2, 'days')
			.locale('en-nz')
			.format('X')
			.toString(),
		end: moment()
			.locale('en-nz')
			.format('X')
			.toString(),
		shortcut: null,
	};
	// offset = current date - end date(offset is how far back it will look)
	// nDays = end date - start date (nDays is how many days back from the offset)

	public async mounted() {
		const types: any = await new EventTypesApi().getEventTypes();
		this.specialEventTypes = types.data.data
			.filter((type: any) => type.productType === 'milk' && type.isSpecial)
			.map((type: any) => type.name);

		this.graphData();
	}

	public beforeDestroy() {
		if (this.lineChart) {
			this.lineChart.dispose();
		}
	}
	public async dateChange() {
		if (this.dateForm.end === null || this.dateForm.start === null) {
			return;
		}
		// if (this.lineChart) {
		//   this.lineChart.dispose();
		// }
		this.graphData();
	}

	public async graphData() {
		if (!this.vatId) {
			return;
		}
		try {
			const { data } = await new GraphsApi().graph(
				'vat',
				parseInt(this.vatId, 10),
				this.dateForm.start,
				this.dateForm.end,
			);

			const emptyVolumeResponse = await this.axios.get(
				process.env.VUE_APP_API_URL.replace(/\/+$/, '') +
					'/vats/convert/convertDistance?distance=' +
					this.vatEmptyDistance +
					'&model=' +
					this.vatSizeString +
					'&offset=' +
					this.vatOffset +
					'&formula=' +
					this.formula +
					'&height=' +
					this.height,
			);
			const { emptyVolume } = emptyVolumeResponse.data;
			await this.loadChart(data.data, emptyVolume, this.specialEventTypes);
		} catch (e) {
			console.log(e);
		} finally {
			// console.log('done');
		}
	}

	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}
	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}
	public async created() {
		window.addEventListener('resize', this.myEventHandler);
	}

	public async loadChart(data: any, emptyVolume: number, specialEventTypes: []) {
		am4core.useTheme(am4themes_animated);

		// am4core.options.queue = true;
		// am4core.options.onlyShowOnViewport = true;

		data.events.forEach((ev: any) => {
			ev['data'] = JSON.stringify(ev['data'], null, 2);
			ev['lineValue'] = 0;
		});
		data.stirrerEvents.forEach((ev: any) => {
			ev['lineValue'] = 0;
		});
		data.vatTempEvents.forEach((ev: any) => {
			ev['lineValue'] = 0;
		});
		data.inletTempEvents.forEach((ev: any) => {
			ev['lineValue'] = 0;
		});
		this.lineChart = am4core.create('chartdiv' + this.vatId, am4charts.XYChart);

		this.lineChart.legend = new am4charts.Legend();

		let interfaceColors = new am4core.InterfaceColorSet();
		this.lineChart.leftAxesContainer.layout = 'vertical';

		let dateAxis = this.createDateAxis();
		let volumeAxis = this.createVolumeAxis(interfaceColors);
		let milkScoreAxis = this.createMilkScoreAxis();
		let stirrerAxis = this.createStirrerAxis();
		let tempAxis = this.createTempAxis();

		// volume series
		this.createSeries(
			data.volume,
			volumeAxis,
			dateAxis,
			{
				name: 'Volume',
				tooltipText: '[bold]Volume |[/] {valueY.value} L',
				color: { stroke: '#002C77' },
				fill: true,
				fillOpacity: 0.3,
			},
			true,
		);

		// fonterra milk score series
		if (data?.milkScore) {
			this.createSeries(data.milkScore, milkScoreAxis, dateAxis, {
				name: 'Milk Score (Fonterra)',
				tooltipText: '[bold]Milk Score (Fonterra) |[/] {valueY.value}',
				color: { stroke: '#6794DC', tooltip: '#0000FF' },
				fill: true,
				interval: 10,
			}).hidden = this.complianceMethod !== 'fonterra';
		}

		// mpi milk score series
		if (data['milkScore/mpi'] != null) {
			this.createSeries(data['milkScore/mpi'], milkScoreAxis, dateAxis, {
				name: 'Milk Score (MPI)',
				tooltipText: '[bold]Milk Score (MPI) |[/] {valueY.value}',
				color: { stroke: '#6794DC', tooltip: '#0000FF' },
				fill: true,
				interval: 10,
			}).hidden = this.complianceMethod !== 'mpi';
		}

		// samr milk score series
		if (data['milkScore/samr'] != null) {
			this.createSeries(data['milkScore/samr'], milkScoreAxis, dateAxis, {
				name: 'Milk Score (SAMR)',
				tooltipText: '[bold]Milk Score (SAMR) |[/] {valueY.value}',
				color: { stroke: '#6794DC', tooltip: '#0000FF' },
				fill: true,
				interval: 10,
			}).hidden = this.complianceMethod !== 'samr';
		}

		// stirrer series
		this.createSeries(data.stirrerValue, stirrerAxis, dateAxis, {
			name: 'Stirrer',
			tooltipText: '[bold]StirrerValue |[/] {valueY.value}',
			color: { stroke: '#505050' },
			fill: false,
		});

		// inlet temp series
		this.createSeries(data.inletTemp, tempAxis, dateAxis, {
			name: 'Inlet Temp',
			tooltipText: '[bold]Inlet Temp |[/] {valueY.value} c',
			color: { stroke: '#DC3545' },
			fill: false,
		});

		// vat temp series
		this.createSeries(data.vatTemp, tempAxis, dateAxis, {
			name: 'Vat Temp',
			tooltipText: '[bold]Vat Temp |[/] {valueY.value} c',
			color: { stroke: '#F6861F' },
			fill: false,
			interval: dateAxis.baseInterval.count * 10,
		});

		let eventAxis = this.createEventAxis(interfaceColors);

		let volumeEventSeries = this.createEventSeries(data.volumeEvents, volumeAxis, {
			valueY: 'value',
			name: 'Volume Events',
			fill: '#002C77',
			tooltipFill: '#FDF9FF',
		});

		this.lineChart.padding(40, 40, 40, 40);

		// volume bullet
		this.createBullet(
			volumeEventSeries,
			'#002C77',
			'[bold]{label} |[/]{value}\nType | {type}\nTime | {dateX}',
		);

		let stirrerEventSeries = this.createEventSeries(data.stirrerEvents, eventAxis, {
			valueY: 'lineValue',
			name: 'Stirrer Events',
			fill: '#505050',
		});

		this.lineChart.padding(40, 40, 40, 40);

		// stirrer bullet
		this.createBullet(
			stirrerEventSeries,
			'#505050',
			'[bold]{label}[/]\nPrevious State | {data.prevState}\nState | {data.state}\nTime | {dateX}',
			12,
		);

		let inletTempEventSeries = this.createEventSeries(data.inletTempEvents, eventAxis, {
			valueY: 'lineValue',
			name: 'Inlet Temp Events',
			fill: '#DC3545',
			tooltipFill: null, // null specifically not to fallback to fill for tooltip background color
		});

		this.lineChart.padding(10, 10, 10, 10);

		// inlet temp bullet
		this.createBullet(
			inletTempEventSeries,
			'#DC3545',
			'[bold]{label} | [/]{value}\nTime | {dateX}',
			-12,
			3,
		);

		let vatTempEventSeries = this.createEventSeries(data.vatTempEvents, eventAxis, {
			valueY: 'lineValue',
			name: 'Vat Temp Events',
			fill: '#F6861F',
			tooltipFill: null,
			autoTextColor: false,
		});

		this.lineChart.padding(40, 40, 40, 40);

		// vat temp bullet
		this.createBullet(
			vatTempEventSeries,
			'#F6861F',
			'[bold]{label} | [/]{value}\nTime | {dateX}',
			-12,
			3,
		);

		let eventSeries = this.createEventSeriesContainer(data.events, eventAxis);

		this.lineChart.padding(40, 40, 40, 40);

		// other events bullet
		this.createOtherEventsBullet(eventSeries, specialEventTypes);

		this.lineChart.cursor = new am4charts.XYCursor();
		this.lineChart.cursor.xAxis = dateAxis;

		this.addHorizontalLine(volumeAxis, emptyVolume);

		let rectangle = this.lineChart.plotContainer.createChild(am4core.Rectangle);
		rectangle.fillOpacity = 1;
		rectangle.width = am4core.percent(100);
		rectangle.fill = am4core.color('#ffffff');
		rectangle.isMeasured = false;
		rectangle.height = 0;
		rectangle.zIndex = 1000;

		eventAxis.events.on('positionchanged', function() {
			rectangle.y = eventAxis.pixelY - rectangle.pixelHeight - 1;
		});
	}

	private addHorizontalLine(
		valueAxis: am4charts.ValueAxis<am4charts.AxisRenderer>,
		yValue: number,
		colorHexCode: string = '#e00000',
	): void {
		const range = valueAxis.axisRanges.create();
		range.value = yValue;

		range.grid.stroke = am4core.color(colorHexCode);
		range.grid.strokeWidth = 2;
		range.grid.strokeOpacity = 1;
		range.grid.strokeDasharray = '0 3 30';

		range.label.inside = true;
		range.label.text = `EmptyVolume | ${yValue} L`;
		range.label.fill = am4core.color('#e00000');
		range.label.background.fill = am4core.color('#fff');
		range.label.background.fillOpacity = 0.3;
		range.label.verticalCenter = 'bottom';
		range.label.dx = 15;
	}

	private createDateAxis(): am4charts.DateAxis {
		let dateAxis = this.lineChart.xAxes.push(new am4charts.DateAxis());

		dateAxis.renderer.grid.template.location = 0;
		dateAxis.renderer.ticks.template.length = 8;
		dateAxis.renderer.ticks.template.strokeOpacity = 0.1;
		dateAxis.renderer.ticks.template.disabled = false;
		dateAxis.renderer.ticks.template.strokeOpacity = 0.2;
		dateAxis.renderer.axisFills.template.disabled = false;
		dateAxis.renderer.axisFills.template.fill = am4core.color('#BBBBBB');
		dateAxis.renderer.axisFills.template.fillOpacity = 0.4;
		dateAxis.renderer.pixelPerfect = true;
		dateAxis.renderer.gridContainer.layout = 'absolute';

		this.lineChart.leftAxesContainer.pixelPerfect = true;
		dateAxis.pixelPerfect = true;
		dateAxis.dateFormatter.dateFormat = 'HH:mm:ss';
		dateAxis.baseInterval = {
			timeUnit: 'minute',
			count: 1,
		};

		let dateFlag = true;
		let day = 0;
		dateAxis.fillRule = (dataItem: any) => {
			if (day !== dataItem.date.getDay()) {
				day = dataItem.date.getDay();
				dateFlag = !dateFlag;
			}
			dataItem.axisFill.visible = dateFlag;
		};

		return dateAxis;
	}

	private createVolumeAxis(interfaceColors: am4core.InterfaceColorSet): am4charts.ValueAxis {
		let volumeAxis = this.lineChart.yAxes.push(new am4charts.ValueAxis());

		volumeAxis.min = 0;
		volumeAxis.max = parseInt(this.vatSizeString?.toString(), 10) * 1.05;
		volumeAxis.strictMinMax = true;
		volumeAxis.height = am4core.percent(90);

		volumeAxis.renderer.baseGrid.disabled = true;
		volumeAxis.renderer.inside = true;
		volumeAxis.renderer.labels.template.verticalCenter = 'bottom';
		volumeAxis.renderer.labels.template.padding(2, 2, 2, 2);
		volumeAxis.renderer.fontSize = '0.8em';
		volumeAxis.renderer.gridContainer.background.fill = interfaceColors.getFor(
			'alternativeBackground',
		);
		volumeAxis.renderer.gridContainer.background.fillOpacity = 0.05;
		volumeAxis.renderer.line.stroke = am4core.color('#002C77');
		volumeAxis.renderer.labels.template.fill = am4core.color('#002C77');

		return volumeAxis;
	}

	private createMilkScoreAxis(): am4charts.ValueAxis {
		let axis = this.lineChart.yAxes.push(new am4charts.ValueAxis());

		axis.tooltip!.disabled = true;
		axis.height = am4core.percent(90);
		axis.hidden = true;

		axis.renderer.baseGrid.disabled = true;
		axis.renderer.inside = true;
		axis.renderer.labels.template.verticalCenter = 'bottom';
		axis.renderer.fontSize = '0.8em';
		axis.renderer.grid.template.disabled = true;
		axis.renderer.opposite = true;

		return axis;
	}

	private createStirrerAxis(): am4charts.ValueAxis {
		let axis = this.lineChart.yAxes.push(new am4charts.ValueAxis());

		axis.tooltip!.disabled = true;
		axis.height = am4core.percent(90);
		axis.hidden = true;
		axis.zIndex = 4;

		axis.renderer.baseGrid.disabled = true;
		axis.renderer.inside = true;
		axis.renderer.labels.template.verticalCenter = 'bottom';
		axis.renderer.fontSize = '0.8em';
		axis.renderer.grid.template.disabled = true;
		axis.renderer.opposite = true;

		return axis;
	}

	private createTempAxis(): am4charts.ValueAxis {
		let tempAxis = this.lineChart.yAxes.push(new am4charts.ValueAxis());

		tempAxis.min = 0;
		tempAxis.height = am4core.percent(90);

		tempAxis.renderer.inside = true;
		tempAxis.renderer.labels.template.verticalCenter = 'bottom';
		tempAxis.renderer.fontSize = '0.8em';
		tempAxis.renderer.opposite = true;
		tempAxis.renderer.line.stroke = am4core.color('#DC3545');
		tempAxis.renderer.labels.template.fill = am4core.color('#DC3545');
		tempAxis.renderer.grid.template.disabled = true;
		tempAxis.renderer.baseGrid.disabled = true;

		return tempAxis;
	}

	private createSeries(
		data: any,
		axis: am4charts.ValueAxis,
		dateAxis: am4charts.DateAxis,
		seriesData: {
			name: string;
			tooltipText: string;
			color: { stroke: string; tooltip?: string };
			fill: boolean;
			fillOpacity?: number;
			interval?: number;
		},
		scrollbar?: boolean,
	): am4charts.LineSeries {
		let series = this.lineChart.series.push(new am4charts.LineSeries());

		series.data = data;
		series.dataFields.dateX = 'timestamp';
		series.dataFields.valueY = 'value';
		series.tooltipText = seriesData.tooltipText;
		series.name = seriesData.name;
		series.yAxis = axis;
		series.stroke = am4core.color(seriesData.color.stroke);
		series.strokeWidth = 2;
		if (seriesData.fill) {
			series.fill = am4core.color(seriesData.color.stroke);
			series.fillOpacity = seriesData.fillOpacity ?? 0;
		}
		if (series?.tooltip) {
			series.tooltip.getFillFromObject = false;
			series.tooltip.background.fill = am4core.color(
				seriesData.color.tooltip ?? seriesData.color.stroke,
			);
		}
		series.connect = false;
		series.autoGapCount = seriesData.interval ?? dateAxis.baseInterval.count * 20; // ~20 minutes between readings, drop it

		if (scrollbar) {
			let scrollbarX = new am4charts.XYChartScrollbar();
			scrollbarX.series.push(series);
			scrollbarX.marginBottom = 25;
			scrollbarX.marginTop = 0;
			this.lineChart.scrollbarX = scrollbarX;
			scrollbarX.height = am4core.percent(15);
		}

		return series;
	}

	private createEventAxis(interfaceColors: am4core.InterfaceColorSet): am4charts.ValueAxis {
		let eventAxis = this.lineChart.yAxes.push(new am4charts.ValueAxis());

		eventAxis.valign = 'middle';
		eventAxis.parent = this.lineChart.plotContainer;
		eventAxis.dataFields.category = 'label';
		eventAxis.marginTop = 10;
		eventAxis.align = 'right';
		if (eventAxis?.tooltip) eventAxis.tooltip.disabled = true;
		eventAxis.height = am4core.percent(10);

		eventAxis.renderer.grid.template.disabled = true;
		eventAxis.renderer.inside = true;
		eventAxis.renderer.labels.template.verticalCenter = 'bottom';
		eventAxis.renderer.maxLabelPosition = 0.95;
		eventAxis.renderer.fontSize = '0.8em';
		eventAxis.renderer.labels.template.disabled = true;
		eventAxis.renderer.gridContainer.background.fill = interfaceColors.getFor(
			'alternativeBackground',
		);
		eventAxis.renderer.gridContainer.background.fillOpacity = 0.05;

		return eventAxis;
	}

	private createEventSeries(
		data: any,
		volumeAxis: am4charts.ValueAxis,
		seriesData: {
			valueY: string;
			name: string;
			fill?: string;
			tooltipFill?: string | null;
			autoTextColor?: boolean;
		},
	): am4charts.LineSeries {
		let series = this.lineChart.series.push(new am4charts.LineSeries());

		series.dataFields.valueY = seriesData.valueY;
		series.dataFields.dateX = 'timestamp';
		series.yAxis = volumeAxis;
		series.data = data;
		series.name = seriesData.name;
		series.strokeOpacity = 0;
		if (seriesData.fill) series.fill = am4core.color(seriesData.fill);

		if (series?.tooltip) {
			series.tooltip.pointerOrientation = 'down';
			series.tooltip.label.minWidth = 40;
			series.tooltip.label.minHeight = 40;
			series.tooltip.label.textAlign = 'middle';
			series.tooltip.label.textValign = 'middle';
			if (seriesData.tooltipFill !== null)
				series.tooltip.label.backgroundColor = am4core.color(
					seriesData.tooltipFill ?? seriesData.fill,
				);
			if (seriesData.autoTextColor != undefined)
				series.tooltip.autoTextColor = seriesData.autoTextColor;
		}

		return series;
	}

	private createEventSeriesContainer(
		data: any,
		eventAxis: am4charts.ValueAxis,
	): am4charts.LineSeries {
		let eventSeries = this.lineChart.series.push(new am4charts.LineSeries());

		eventSeries.dataFields.valueY = 'lineValue';
		eventSeries.dataFields.dateX = 'timestamp';
		eventSeries.yAxis = eventAxis;
		eventSeries.width = am4core.percent(20);
		eventSeries.data = data;
		eventSeries.name = 'Other Events';
		eventSeries.strokeOpacity = 0;
		eventSeries.fill = am4core.color('#28A745');

		if (eventSeries?.tooltip) {
			eventSeries.tooltip.pointerOrientation = 'down';
			eventSeries.tooltip.label.minWidth = 40;
			eventSeries.tooltip.label.minHeight = 40;
			eventSeries.tooltip.label.textAlign = 'middle';
			eventSeries.tooltip.label.textValign = 'middle';
			eventSeries.tooltip.label.maxWidth = 400;
			eventSeries.tooltip.label.wrap = true;
		}

		return eventSeries;
	}

	private createBullet(
		eventSeries: am4charts.LineSeries,
		color: string,
		tooltipText?: string,
		yOffset?: number,
		radius?: number,
	): am4charts.CircleBullet {
		let bullet = eventSeries.bullets.push(new am4charts.CircleBullet());

		bullet.circle.strokeWidth = 1;
		bullet.circle.stroke = am4core.color(color);
		bullet.circle.fill = am4core.color(color);
		bullet.circle.fillOpacity = 0.3;
		bullet.circle.propertyFields.radius = `${radius ?? 6}`;
		bullet.circle.propertyFields.fill = 'fill';
		if (tooltipText) {
			bullet.tooltipText = tooltipText;
			bullet.circle.showTooltipOn = 'hover';
		}

		if (yOffset != null) bullet.circle.dy = yOffset;

		let hoverState = bullet.states.create('hover');
		hoverState.properties.scale = 1.7;

		return bullet;
	}

	private createOtherEventsBullet(
		eventSeries: am4charts.LineSeries,
		specialEventTypes: [],
	): am4charts.CircleBullet {
		let bullet = this.createBullet(eventSeries, '#28A745');

		bullet.adapter.add('showOnInit', function(showOnInit, target) {
			console.log(target?.dataItem?._dataContext?.value);
			if (specialEventTypes.includes(target?.dataItem?._dataContext?.value)) {
				target.events.on('inited', function(event) {
					animateExpand(event.target);
				});
				let secondCircle = target.createChild(am4core.Circle);
				secondCircle.radius = bullet.circle.radius;

				secondCircle.events.on('inited', function(event) {
					animateExpand2(event.target);
				});
				target.fill = am4core.color('red');
			}
			return true;
		});

		bullet.tooltipHTML = `<h5><strong style="text-transform: capitalize;">--{label}::{value}--</strong></h5>
            <table style="width:100%;">
            <tr>
              <th align="left"style="white-space: nowrap"> Value |</th>
              <td align="left">{value}</td>
            </tr>
            <tr>
              <th align="left"style="white-space: nowrap">Time |</th>
              <td align="left">{dateX}</td>
            </tr>
            <tr>
              <th align="left" valign="top" style="white-space: nowrap">Data |</th>
              <td align="left" style=" white-space: normal">{data}</td>
            </tr>
         </table>
    `;

		return bullet;
	}
}
